import { coreService } from 'Src/network/AutomatedService';
import { definitions } from 'Src/vendor/posapi/pos';

type FeeOrGratuity = definitions['types.Surcharge'];

const service = {
  getAll: coreService['POS:GET:Fees'],
};

export type { FeeOrGratuity };
export default service;
